var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { palette } from '../../../constants';
var DEFAULT_STROKE_WIDTH = 1;
var defaultBorderStyles = {
    stroke: palette.neutral4,
    strokeWidth: DEFAULT_STROKE_WIDTH,
    shapeRendering: 'optimizespeed' // Prevents anti-aliasing from blurring stroke, maintaining crisp borders
};
function getDefaults(_a) {
    var all = _a.all, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, margins = _a.margins, width = _a.width, height = _a.height;
    var boundedWidth = width - margins.left - margins.right;
    var boundedHeight = height - margins.top - margins.bottom;
    var shared = __assign(__assign({}, defaultBorderStyles), all);
    return {
        all: shared,
        top: __assign(__assign({ x1: margins.left, x2: boundedWidth + margins.left, y1: margins.top, y2: margins.top }, shared), top),
        right: __assign(__assign({ x1: margins.left + boundedWidth, x2: margins.left + boundedWidth, y1: margins.top, y2: margins.top + boundedHeight }, shared), right),
        bottom: __assign(__assign({ x1: margins.left, x2: margins.left + boundedWidth, y1: margins.top + boundedHeight, y2: margins.top + boundedHeight }, shared), bottom),
        left: __assign(__assign({ x1: margins.left, x2: margins.left, y1: margins.top, y2: margins.top + boundedHeight }, shared), left)
    };
}
export var Borders = function (_a) {
    var margins = _a.margins, _b = _a.borders, borders = _b === void 0 ? {} : _b, width = _a.width, height = _a.height;
    var borderProps = React.useMemo(function () { return getDefaults(__assign(__assign({}, borders), { margins: margins, width: width, height: height })); }, [borders, margins, width, height]);
    return (React.createElement(React.Fragment, null,
        React.createElement("line", __assign({ className: "Borders--top" }, borderProps.top)),
        React.createElement("line", __assign({ className: "Borders--right" }, borderProps.right)),
        React.createElement("line", __assign({ className: "Borders--bottom" }, borderProps.bottom)),
        React.createElement("line", __assign({ className: "Borders--left" }, borderProps.left))));
};
//# sourceMappingURL=Borders.js.map